import { useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/site/Logo";
import Contact from "@/components/site/Contact";
import { CONTACT } from "@/components/site/config";
import { initExtraPixel } from "@/lib/metaPixel";
import { Seo } from "@/components/seo/Seo";

// Minimal landing page for paid ads — no site nav/footer, form front and center.
const EnquirePage = () => {
  useEffect(() => {
    initExtraPixel(process.env.REACT_APP_META_PIXEL_ID_ENQUIRE);
  }, []);

  return (
    <div className="App grain min-h-screen" data-testid="enquire-page">
      <Seo title="Tell Us About Your Business" description="Send an enquiry or book a strategy call with Viral Vision Media. Tell us where the business is now, where you want to take it and what's getting in the way." />
      <header className="border-b border-[#2E1B16]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <Link to="/" data-testid="enquire-logo" aria-label="Viral Vision Media home">
            <Logo />
          </Link>
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="enquire-email-link"
            className="hidden sm:block text-sm font-semibold text-[#2E1B16]/60 hover:text-[#2E1B16] transition-colors"
          >
            {CONTACT.email}
          </a>
        </div>
      </header>
      <main>
        <Contact
          pageLabel="Dedicated Enquiry Page"
          eyebrow="Enquire now"
          title={<>Tell us about your <span className="font-accent font-normal normal-case text-[#38BDF8]">business.</span></>}
          subtitle="You don't need to know exactly what marketing you need. Tell us where the business is now, where you're trying to take it and what's getting in the way. We'll take it from there."
          sectionClassName="pt-14 md:pt-20 pb-24 md:pb-32"
          headingTag="h1"
        />
      </main>
    </div>
  );
};

export default EnquirePage;
